import { HttpInterceptorFn } from '@angular/common/http';
import { SessionStorageService } from '../services/session-storage.service';
import { inject } from '@angular/core';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionStorageService = inject(SessionStorageService);
  const IdToken = sessionStorageService.getItem('IdToken');
    // Clone the request and add the role header
    const modifiedReq = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${IdToken || ''}`
      }
    });
    return next(modifiedReq);
};
